import { z } from "zod";
import logger from "@shared/utils/logger";

// TODO<Jason>: Seems what used to be a Mongo ObjectId format (24 char hex, no dashes)
const LEGACY_APP_ID_PATTERN = /[a-fA-F0-9]{24}/;
// UUID-shaped app ID (8-4-4-4-12 hex groups).
const UUID_APP_ID_PATTERN =
  /[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/;
const APP_ID_PATTERN = new RegExp(
  `^((test)_)?(${LEGACY_APP_ID_PATTERN.source}|${UUID_APP_ID_PATTERN.source})$`,
);

export const envSchema = z.object({
  VITE_LOG_LEVEL: z.enum(["debug", "info", "warn", "error", "silent"]),
  VITE_APP_NAME: z.string(),
  VITE_CLIENT_ID: z.string().regex(/^[a-fA-F0-9]{24}$/, {
    error: `Expected a 24 character hexadecimal string`,
  }),
  VITE_APP_ID: z
    .string()
    // Match e.g. "test_5c00b13d00b13d0000000000"
    .regex(APP_ID_PATTERN, {
      error: `Expected a UUID or 24 character hexadecimal string, with a possible "test_" prefix`,
    }),
  // NOTE: Commented out as the back-end currently requires it to be
  // supplemented with Android specific headers.
  // .refine((val) => !import.meta.env.DEV || val.startsWith("test_"), {
  //   error: `Ensure "test_" is used in development`,
  // }),
  VITE_CHARGETRIP_URL: z.url({
    protocol: /^https$/,
    hostname: /\.chargetrip\.(dev|io|space)$/,
    error: `Ensure protocol uses "https://" and hostname includes ".chargetrip.dev" or ".chargetrip.io"`,
  }),
  VITE_CHARGETRIP_GRAPHQL_ENDPOINT: z.url({
    protocol: /^https$/,
    hostname: /\.chargetrip\.(dev|io|space)$/,
    error: `Ensure protocol uses "https://" and hostname includes ".chargetrip.dev" or ".chargetrip.io"`,
  }),
  VITE_CHARGETRIP_GRAPHQL_WS_TRANSPORT_ENDPOINT: z.url({
    protocol: /^wss$/,
    hostname: /\.chargetrip\.(dev|io)$/,
    error: `Ensure protocol uses "wss://" and hostname includes ".chargetrip.dev" or ".chargetrip.io"`,
  }),
  VITE_CHARGETRIP_TILE_SERVICE_ORIGIN: z.url({
    protocol: /^https$/,
    hostname: /\.chargetrip\.(dev|io|space)$/,
    error: `Ensure protocol uses "https://" and hostname includes ".chargetrip.dev" or ".chargetrip.io"`,
  }),
  VITE_MAPBOX_ACCESS_TOKEN: z.string(),
  VITE_MAPBOX_STYLE: z
    .url({
      protocol: /^mapbox$/,
      error: `Ensure protocol uses "mapbox://"`,
    })
    .refine((val) => !(import.meta.env.PROD && val.endsWith("/draft")), {
      error: `Ensure Mapbox style is not a draft`,
    }),
  VITE_GOOGLE_MAPS_API_KEY: z.string(),
  VITE_SEARCH_PROVIDER_API_KEY: z.string(),
  VITE_GENAI_ROUTES_API_KEY: z.string(),
});

export const validateEnv = (env: Record<string, string | undefined>): void => {
  const parsedEnv = envSchema.safeParse(env);
  if (!parsedEnv.success) {
    logger.error(
      "Environment variable validation failed:",
      z.treeifyError(parsedEnv.error),
    );
  }
};
